import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '../../services/services';
import { route } from '../../services/utils';
import { TOKENS_EDIT, TOKENS_INDEX } from '../../router/routes';
import Form from '../../components/form';
import Group from '../../components/form/elements/group';
import Text from '../../components/form/elements/text';
import Link from '../../components/form/elements/link';
import { useObservableState } from 'observable-hooks';
import Token from '../../interfaces/token';
import { useHistory, useParams } from 'react-router';
import Date from '../../components/form/elements/date';
import OptionModal from '../../components/modals/option-modal';
import Button from '../../components/form/elements/button';
import Notices from '../../components/common/notices';

export default function ApiTokenView() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { tokenService } = useService();
  const history = useHistory();
  const [modal, setModal] = useState(null);
  const [footer, setFooter] = useState(null);
  const [token] = useObservableState<Token>(() => tokenService.show(id), null);

  const destroy = useCallback(() => {
    setModal(
      <OptionModal
        title={t(token.name)}
        content={t('pages.tokens.delete.content')}
        buttons={[
          { title: t('yes'), name: 'yes', value: true },
          { title: t('no'), name: 'no', value: false },
        ]}
        onChoice={(choice) => {
          if (choice) {
            tokenService.destroy(id).subscribe(() => {
              history.push(route(TOKENS_INDEX));
            });
          } else {
            setModal(null);
          }
        }}
        onClose={() => setModal(null)}
      />
    );
  }, [setModal, history, id, t, tokenService, token]);

  useEffect(() => {
    const footerElements = [Button('delete', destroy)];
    if (token && !token.not_editable) {
      footerElements.push(Link(route(TOKENS_EDIT, { id }), 'edit', true));
    }

    setFooter(footerElements);
  }, [token, id, destroy, setFooter]);

  const [body] = useState(() => [
    Group([
      Text('name', 'pages.tokens.name'),
      Date('last_used_at', 'pages.tokens.last_used_at'),
      Date('created_at', 'pages.tokens.created_at'),
      Date('updated_at', 'pages.tokens.updated_at'),
    ]),
  ]);

  return (
    <>
      {modal}
      <Notices accessor={'TokenErrors'}>
        <> </>
      </Notices>
      <Form
        title={'pages.tokens.view-token'}
        backTo={route(TOKENS_INDEX)}
        mode="view"
        body={body}
        footer={footer}
        values={token}
      />
    </>
  );
}
